var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    fill: "none",
    style: {
      fill: "none"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1c-.695 0-1.323.335-1.676.903l-9.06 14.618a1.71 1.71 0 0 0 0 1.83c.396.637 1.056.905 1.752.904h17.967c.697.002 1.357-.267 1.752-.903.354-.57.353-1.26 0-1.83l-9.059-14.62C13.323 1.335 12.695 1 12 1m0 1.521c.096 0 .242.08.285.15l9.059 14.619a.33.33 0 0 1 0 .285c-.002.003-.265.159-.36.159H3.015c-.096 0-.358-.156-.36-.159a.33.33 0 0 1 0-.285l9.059-14.618a.42.42 0 0 1 .285-.15Zm0 4.057c-.444 0-.805.34-.805.76v5.832c0 .42.36.76.805.76.444 0 .804-.34.804-.76V7.338c0-.42-.36-.76-.804-.76m0 8.113c-.592 0-1.073.454-1.073 1.014s.48 1.014 1.073 1.014c.592 0 1.073-.454 1.073-1.014s-.48-1.014-1.073-1.014"
  })));
};
export default SvgWarningIcon;